module.exports = function() {
  return new Worker(__webpack_public_path__ + "09d461efa0de536a8fff.worker.js");
};